import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'
import * as garmentStyles from "../css/garment.module.css"
import { Container, Col, Row } from "react-bootstrap"

import BackgroundImage from 'gatsby-background-image'

const BackgroundSection = ({ className }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop: file(relativePath: { eq: "hero-garment.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      // Set ImageData.
      const imageData = data.desktop.childImageSharp.fluid
      return (
        <BackgroundImage
          Tag="section"
          className={className}
          fluid={imageData}
          backgroundColor={`#040e18`}
        >
         <Container fluid="xl" className={garmentStyles.hero}>
              <Row>
                  <Col><h1 className={garmentStyles.heroheader}>ด้ายเย็บกระสอบ</h1><p>ผู้ผลิตนำเข้าและจำหน่ายอุปกรณ์ตัดเย็บ เส้นด้ายอุตสาหกรรม ทุกชนิด</p></Col>
              </Row>
          </Container>
        </BackgroundImage>
      )
    }}
  />
)

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  background-position: bottom center;
  background-repeat: repeat-y;
  background-size: cover;
`

export default StyledBackgroundSection